import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { map, tap, withLatestFrom } from 'rxjs';
import { PagePath } from '../enums/page-path.enum';
import { DrugsStateService } from '../services/drugs-state.service';
import { GuardsContextService } from '../services/guards-context.service';
import { NavigationService } from '../services/navigation.service';

export const selectedDrugGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  guardsContextService = inject(GuardsContextService),
  drugsStateService = inject(DrugsStateService),
  navigationService = inject(NavigationService)
) => {
  return guardsContextService.getIsProcessingAuth$().pipe(
    withLatestFrom(drugsStateService.hasSelectedDrug$()),
    tap(([isProcessingAuth, hasSelectedDrug]) => {
      if (!isProcessingAuth && !hasSelectedDrug) {
        navigationService.navigateToPagePath([PagePath.ACCOUNT_PRESCRIPTIONS]);
      }
    }),
    map(([isProcessingAuth, hasSelectedDrug]) => isProcessingAuth || hasSelectedDrug)
  );
};
